import React from 'react';
import PropTypes from 'prop-types';

const ReportIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18.395 16">
        <path d="M16.086.857a1.117 1.117 0 00-1.341-.823l-6.2 1.451a.475.475 0 00.218.924l6.2-1.459a.167.167 0 01.2.125l2.276 9.7a.167.167 0 01-.125.2L5.522 13.752a.474.474 0 00.108.935.482.482 0 00.11-.013l1.328-.317a.468.468 0 00.057.021l5.9 1.582a1.117 1.117 0 001.362-.8l.7-2.69 2.455-.569a1.117 1.117 0 00.831-1.341zm-2.62 14.073a.165.165 0 01-.078.1.161.161 0 01-.123.019L9.01 13.907l5.031-1.186zm-1.789-8.257a.734.734 0 00.4.118.746.746 0 00.159-.017l1.9-.415a.742.742 0 00.569-.88 2.684 2.684 0 00-3.207-2.054.742.742 0 00-.569.88l.415 1.9a.734.734 0 00.333.464zm1.328-2.087a1.722 1.722 0 01.7.886l-1.472.328-.324-1.478a1.721 1.721 0 011.1.264zm-2.716.728a.62.62 0 00-.486-.064 2.969 2.969 0 00.821 5.822 2.9 2.9 0 00.489-.036 2.982 2.982 0 002.436-3.386.624.624 0 00-.749-.5l-1.821.4-.4-1.821a.628.628 0 00-.29-.419zm.605 3.215l1.741-.379a2.02 2.02 0 11-2.9-1.857l.379 1.741a.654.654 0 00.78.5zm-8.419 6.949a.9.9 0 00.584-.214 7.3 7.3 0 002.371-3.828l2-8.415A2.109 2.109 0 005.856.457a2.149 2.149 0 00-2.537 1.6l-.144.582-.083.353-.994-.246a.92.92 0 00-1.113.673L.012 7.336a.474.474 0 00.345.569.48.48 0 00.114.013.474.474 0 00.459-.36l.968-3.888.977.243-1.54 6.512a7.3 7.3 0 00.305 4.488.9.9 0 00.835.569zm-.22-4.821l1.843-7.782.144-.58a1.2 1.2 0 011.4-.9 1.161 1.161 0 01.867 1.415l-2 8.417a6.351 6.351 0 01-2.011 3.27 6.358 6.358 0 01-.243-3.84z" fill={fill} />
    </svg>
);

ReportIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ReportIcon.defaultProps = {
    width: '18.395',
    height: '16',
    fill: '#4b254e'
};

export default ReportIcon;
